import React from "react";
import { graphql, useStaticQuery, Link } from "gatsby";

import clsx from "clsx";
// import PubSub from "pubsub-js";
// import SanityImage from "./SanityImage";

const query = graphql`
  query {
    allSanityCategory {
      nodes {
        slug {
          current
        }
        title
      }
    }
    allSanityProduct {
      nodes {
        category {
          title
        }
        title
        slug {
          current
        }
        images {
          asset: _rawAsset
        }
      }
    }
  }
`;

const MenuShopMobile = () => {
  const { allSanityCategory } = useStaticQuery(query);

  return (
    <nav className={clsx("menu-shop ")}>
      <div className={clsx("inner bg-white px-md")}>
        {/* <Pre input={grouped}></Pre> */}
        <div className='flex justify-between'>
          <ul className='flex flex-col '>
            <li className='menu-item text-sm-lg md:text-base'>
              <Link to={`/shop/`}>
                <div className='title'>All</div>
              </Link>
            </li>
            {allSanityCategory.nodes.map((li, i) => (
              <li key={i} className='menu-item text-sm-lg md:text-base'>
                <Link to={`/category/${li.slug.current}`}>
                  <div className='title'>{li.title}</div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default MenuShopMobile;
